export const PUT_ORDER_DISCOUNTS_START = 'OVID/PUT_ORDER_DISCOUNTS_START'
export const PUT_ORDER_DISCOUNTS_SUCCESS = 'OVID/PUT_ORDER_DISCOUNTS_SUCCESS'
export const PUT_ORDER_DISCOUNTS_FAILED = 'OVID/PUT_ORDER_DISCOUNTS_FAILED'
